module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "module-cont"
  }, [_c('left-ad', {
    attrs: {
      "data": _vm.leftAdv.advList
    }
  }), _vm._v(" "), _c('middle-ad', {
    attrs: {
      "middleUpAdv": _vm.middleUpAdv,
      "middleDownAdv": _vm.middleDownAdv
    }
  }), _vm._v(" "), _c('right-ad', {
    attrs: {
      "data": _vm.rightGoodsAdv.advList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6d00c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/home-module/index.vue
// module id = 1662
// module chunks = 1